// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"438":"component---src-page-js","634":"2c796e83"}[chunkId] || chunkId) + "-" + {"438":"9a5990d94125a60b7fca","634":"2c36d032a8b6fe6dc59a","867":"b4fdfccb80a3fdb052cd"}[chunkId] + ".js";
};